import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, MailIcon, SmartphoneIcon } from 'lucide-react';
import { PRICE, TOTAL_VALUE, valueStack } from '../data/content';
import { formatArs } from '../utils/currency';
import { CtaButton } from './CtaButton';
const reassurance = [{
  icon: MailIcon,
  text: 'Entrega instantánea por email'
}, {
  icon: SmartphoneIcon,
  text: 'PDF para leer en el celular'
}, {
  icon: LockIcon,
  text: 'Pago único, sin suscripciones'
}];
export function OfferSection() {
  return <section id="oferta" className="w-full scroll-mt-20 border-y border-white/10 bg-ink-900 py-16 sm:py-20" aria-labelledby="oferta-title" data-id="element-89" data-mp="mds9bu87s2fy">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-90" data-mp="wczommyie75p">
        <h2 id="oferta-title" className="text-center font-display text-3xl font-bold uppercase text-white sm:text-4xl" data-id="element-91" data-mp="wchhgvab68j0">
          El pack completo
        </h2>
        <p className="mt-3 text-center text-base text-white/60" data-id="element-92" data-mp="2y55ozgtzji4l">
          Si te sumás hoy, te llevás el arsenal completo de supervivencia:
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-white/10 bg-ink-950" data-id="element-93" data-mp="xws4by3vpqu1">
          <ul data-id="element-94" data-mp="sxp1mkbdfwp8">
            {valueStack.map((item, index) => <motion.li key={item.label} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.35,
            delay: index * 0.05
          }} className={`flex items-center justify-between gap-4 border-b border-white/[0.07] px-5 py-4 sm:px-6 ${item.isMain ? 'bg-amber-brand/[0.07]' : ''}`} data-id="element-95" data-mp="sxysea48q7vz" data-mpi={index}>
                <div className="flex items-start gap-3" data-id="element-96" data-mp="17mbr3eupq4u6">
                  <span aria-hidden="true" className="text-lg leading-6" data-id="element-97" data-mp="16sywcj0z8fo">
                    {item.icon}
                  </span>
                  <span className={`text-[15px] leading-snug ${item.isMain ? 'font-semibold text-white' : 'text-white/75'}`} data-id="element-98" data-mp="3sb996dq31mv0">
                    {item.label}
                  </span>
                </div>
                <span className="shrink-0 font-display text-lg font-bold tabular-nums text-white/45 line-through" data-id="element-99" data-mp="3ouwlik2ey0e4">
                  {formatArs(item.price)}
                </span>
              </motion.li>)}
          </ul>

          <div className="flex items-center justify-between gap-4 px-5 py-5 sm:px-6" data-id="element-100" data-mp="3fuhwb9mbw15c">
            <span className="font-display text-xl font-bold uppercase tracking-wide text-white" data-id="element-101" data-mp="315u5fgnfgflq">
              Valor total
            </span>
            <span className="font-display text-2xl font-bold tabular-nums text-white/45 line-through" data-id="element-102" data-mp="364yca0mvq18w">
              {formatArs(TOTAL_VALUE)} ARS
            </span>
          </div>
        </div>

        <div className="mt-8 rounded-2xl border-2 border-amber-brand bg-ink-950 p-6 text-center shadow-cta sm:p-9" data-id="element-103" data-mp="2x37b993aaild">
          <p className="text-[15px] leading-relaxed text-white/65" data-id="element-104" data-mp="2dk1d3j47i8nn">
            Queremos que dejes de tirar plata en el taller. Por eso, durante
            esta fase de lanzamiento:
          </p>
          <p className="mt-6 font-display text-sm font-bold uppercase tracking-[0.22em] text-amber-brand" data-id="element-105" data-mp="2mjy4hshzdlme">
            Inversión única hoy
          </p>
          <p className="mt-1 font-display text-6xl font-bold tabular-nums leading-none text-white sm:text-7xl" data-id="element-106" data-mp="2wg18z50b1wci">
            {formatArs(PRICE)}
            <span className="ml-2 align-middle text-2xl text-white/50" data-id="element-107" data-mp="2rhg8r5l1zco2">ARS</span>
          </p>
          <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-white/55" data-id="element-108" data-mp="365t4q2k54vik">
            Equivale a lo que gastás en dos bidones de aceite o una carga de
            nafta. Se paga solo con tu primer ahorro.
          </p>

          <div className="mt-8" data-id="element-109" data-mp="3a87qauf729dj">
            <CtaButton location="oferta" data-id="element-110" data-mp="3a9906vkh4pto" />
          </div>

          <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-111" data-mp="18j1srx9aova4">
            {reassurance.map(({
            icon: Icon,
            text
          }) => <li key={text} className="flex items-center gap-2 text-sm text-white/50" data-id="element-112" data-mp="1dhbs8k21yi1j">
                <Icon className="h-4 w-4 text-amber-brand" aria-hidden="true" data-id="element-113" data-mp="1i9mye4ndz02j" />
                {text}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}